import React, { useEffect, useState, useRef } from 'react';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { SplitIntro } from '../components/SplitIntro';
import { ServicesGrid } from '../components/ServicesGrid';
import { Showcase } from '../components/Showcase';
import { BeyondCocktails } from '../components/BeyondCocktails';
import { Footer } from '../components/Footer';
import { motion } from 'framer-motion';
import { useScreenInit } from '../useScreenInit';
export function Home() {
  const {
    section
  } = useScreenInit();
  const heroRef = useRef<HTMLDivElement>(null);
  const introRef = useRef<HTMLDivElement>(null);
  const servicesRef = useRef<HTMLDivElement>(null);
  const beyondRef = useRef<HTMLDivElement>(null);
  const showcaseRef = useRef<HTMLDivElement>(null);
  const footerRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const refs: Record<string, React.RefObject<HTMLDivElement>> = {
      hero: heroRef,
      intro: introRef,
      services: servicesRef,
      beyond: beyondRef,
      showcase: showcaseRef,
      footer: footerRef
    };
    if (section && refs[section]?.current) {
      refs[section].current?.scrollIntoView({
        behavior: 'smooth'
      });
    }
  }, [section]);
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} exit={{
    opacity: 0
  }} transition={{
    duration: 0.5
  }} className="min-h-screen bg-#[#000000] selection:bg-#[#992f74] selection:text-white" data-id="element-409">
      <Header data-id="element-410" />
      <main data-id="element-411">
        <div ref={heroRef} data-id="element-412">
          <Hero data-id="element-413" />
        </div>

        <section className="py-12 pb-3 bg-black text-center overflow-hidden" data-id="element-414">
          <motion.h2 initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} className="font-montserrat text-3xl md:text-5xl text-[#992f74]" data-id="element-415">
            Elevate Your Gatherings. Craft Connections.
          </motion.h2>
        </section>

        <div ref={introRef} data-id="element-416">
          <SplitIntro data-id="element-417" />
        </div>
        <div ref={servicesRef} data-id="element-418">
          <ServicesGrid data-id="element-419" />
        </div>
        <div ref={beyondRef} data-id="element-420">
          <BeyondCocktails data-id="element-421" />
        </div>

        {/* Review Widget Slider Placeholder */}
        <section className="py-16 px-6 bg-[#0A0A0A] border-t border-white/5" data-id="element-422">
          <div className="max-w-4xl mx-auto text-center space-y-12" data-id="element-423">
            <span className="text-[15px] font-black tracking-[0.4em] text-[#992f74] uppercase font-montserrat" data-id="element-424">
              The Experience
            </span>
            <motion.div initial={{
            opacity: 0
          }} whileInView={{
            opacity: 1
          }} className="text-2xl md:text-3xl font-light italic text-white/90 leading-relaxed font-montserrat" data-id="element-425">
              "Professional, fresh ingredients, master mixologists who deliver
              on the vibes. Liquid Courage transformed our wedding into a
              high-end lounge experience."
            </motion.div>
            <p className="text-xs uppercase tracking-widest text-white/40" data-id="element-426">
              — Sarah & James, Malibu 2025
            </p>
          </div>
        </section>

        <div ref={showcaseRef} data-id="element-427">
          <Showcase data-id="element-428" />
        </div>
      </main>
      <div ref={footerRef} data-id="element-429">
        <Footer data-id="element-430" />
      </div>
    </motion.div>;
}